var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconawesomeTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.99,
    height: 15.423,
    viewBox: "0 0 18.99 15.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#26093a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.038,7.225c.012.169.012.337.012.506A11,11,0,0,1,5.977,18.8,11,11,0,0,1,0,17.057a8.051,8.051,0,0,0,.94.048,7.8,7.8,0,0,0,4.832-1.663,3.9,3.9,0,0,1-3.639-2.7,4.908,4.908,0,0,0,.735.06,4.116,4.116,0,0,0,1.024-.133A3.893,3.893,0,0,1,.771,8.851V8.8A3.92,3.92,0,0,0,2.53,9.3a3.9,3.9,0,0,1-1.2-5.205A11.063,11.063,0,0,0,9.35,8.164a4.394,4.394,0,0,1-.1-.892A3.9,3.9,0,0,1,15.99,4.61a7.663,7.663,0,0,0,2.47-.94,3.881,3.881,0,0,1-1.711,2.145,7.8,7.8,0,0,0,2.241-.6,8.366,8.366,0,0,1-1.952,2.012Z",
    transform: "translate(0 -3.381)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeTwitter);
export default __webpack_public_path__ + "static/media/Icon awesome-twitter.6322a47597d22267cc53637f4ed8bb7c.svg";
export { ForwardRef as ReactComponent };